
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return /^((4|88|90)9|52)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
